/* eslint-disable import/no-cycle */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable arrow-body-style */
import { ResultsStatus } from '@src/common/types';
import { create } from 'zustand';
import { getInfiniteScrollManagerInstance } from '@src/common/util/infiniteScrollManager';
import { eventSequenceManager } from '@src/common/util/eventSequenceManager';
import { RaFilterPanelState, RiskScoresResultsStore } from '../types';
import { fetchRiskScores } from '../api/fetchRiskScores';
import { riskScoresFilterPanelsApi } from './riskScoresFilterPanel.state';

export const useRiskScoreResultsStore = create<RiskScoresResultsStore>(() => {
  return {
    resultStatus: ResultsStatus.searching,
    riskScoreTableData: [],
    totalElements: 0,
    loadingMore: false,
    moreToLoad: true,
    pageIndex: 0,
  };
});

export const riskScoresResultsApi = api();

function api() {
  const store = useRiskScoreResultsStore;
  const raceConditionDetector = eventSequenceManager();
  const infiniteScrollManager = getInfiniteScrollManagerInstance();
  infiniteScrollManager.onTriggered(loadMoreTableItems);

  return {
    search,
    resetUi,
    setInfiniteScrollElement: (e) => {
      console.log('setInfiniteScrollElement: ', e);
      infiniteScrollManager.setTriggerElement(e);
    },
    loadMoreTableItems,
  };

  async function search(fpState: RaFilterPanelState) {
    const snapshot = raceConditionDetector.queueEvent();
    const pageIndex = 0;
    store.setState({
      resultStatus: ResultsStatus.searching,
      pageIndex,
      moreToLoad: false,
      loadingMore: false,
    });
    const { resultStatus, result } = await fetchRiskScores(fpState, pageIndex);

    // user has clicked the search button again, ignore this result
    if (snapshot.isStale()) {
      return;
    }

    store.setState({
      resultStatus,
      riskScoreTableData: result.content,
      totalElements: result.totalElements,
      moreToLoad: !result.last,
    });
  }
  function resetUi() {
    store.setState({
      resultStatus: ResultsStatus.searching,
      totalElements: 0,
    });
  }
  async function loadMoreTableItems() {
    const snapshot = raceConditionDetector.queueEvent();
    riskScoresFilterPanelsApi.setSearchDisabled();
    const nextPageIndex = store.getState().pageIndex + 1;
    store.setState({
      loadingMore: true,
      pageIndex: nextPageIndex,
    });
    const fpState = riskScoresFilterPanelsApi.getCommittedSearchProps();
    const { result } = await fetchRiskScores(fpState, nextPageIndex);

    // user has clicked the search button again, ignore this result
    if (snapshot.isStale()) {
      return;
    }

    const riskScoreTableData = [
      ...store.getState().riskScoreTableData,
      ...result.content,
    ];
    store.setState({
      loadingMore: false,
      moreToLoad: !result.last,
      riskScoreTableData,
    });
    riskScoresFilterPanelsApi.setSearchRestored();
  }
}
